import { Result as SundayResult } from "sunday-component";
import Head from "next/head";
import styled from "styled-components";
import { useTranslation } from "react-i18next";
import { serverSideTranslations } from "next-i18next/serverSideTranslations";
import { GetServerSidePropsContext } from "next";
import { withLayout } from "src/components/Layout/withLayout";

const Result = styled(SundayResult)`
  margin: auto;
  max-width: 790px;
`;

export function Custom500() {
  const { t } = useTranslation("500");

  return (
    <>
      <Head>
        <title>500</title>
      </Head>
      <Result status="500" title={t("title")} subTitle={t("description")} />
    </>
  );
}

export async function getStaticProps(context: GetServerSidePropsContext) {
  return {
    props: {
      ...(await serverSideTranslations(context.locale, [
        "main-page",
        "common",
        "cookie-consent",
        "500",
        "layout",
        "otp-form",
      ])),
    },
  };
}

export default withLayout(Custom500);
